import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import SourceMaster from "./sourceMaster";

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {},
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(SourceMaster);
